import { Routes } from "@angular/router";
import { ENROLLMENT_SHARED_USER_TYPES } from "./core/constants/shared.access";
import { AuthGuard } from "./core/guards/auth.guard";

export const sharedRoutes: Routes = [
  {
    path: "payment-billing",
    canActivate: [AuthGuard],
    data: { userTypes: ENROLLMENT_SHARED_USER_TYPES },
    loadComponent: () =>
      import("./common/payment-billing/payment-billing.component").then(
        (m) => m.PaymentBillingComponent,
      ),
  },
  {
    path: 'message-center',
    loadComponent: () => import("./college-admin-dashbaord/message-center/message-center.component").then(
      (m) => m.MessageCenterComponent
    ),
  },
  {
    path: "announcements",
    loadComponent: () =>
      import("./college-admin-dashbaord/announcement/announcement.component").then(
        (m) => m.AnnouncementComponent,
      ),
  },
  {
    path: "refunds",
    loadComponent: () =>
      import("./college-admin-dashbaord/refunds/refunds.component").then(
        (m) => m.RefundsComponent,
      ),
  },
  {
    path: "student-profile",
    loadComponent: () =>
      import("./college-admin-dashbaord/student-profile/student-profile.component").then(
        (m) => m.StudentProfileComponent,
      ),
  },

  {
    path: "student-profile/:ref",
    loadComponent: () =>
      import("./college-admin-dashbaord/student-profile-details/student-profile-details.component").then(
        (m) => m.StudentProfileDetailsComponent,
      ),
  },

  {
    path: "program-dates",
    loadComponent: () =>
      import("./college-admin-dashbaord/program-dates/program-dates.component").then(
        (m) => m.ProgramDatesComponent,
      ),
  },

  {
    path: "message-templates",
    loadComponent: () =>
      import("./college-admin-dashbaord/message-templates/message-templates.component").then(
        (m) => m.MessageTemplatesComponent,
      ),
  },

  {
    path: "message-panel",
    loadComponent: () =>
      import("./college-admin-dashbaord/message-panel/message-panel.component").then(
        (m) => m.MessagePanelComponent,
      ),
  },

  {
    path: "student-resources",
    loadComponent: () =>
      import("./college-admin-dashbaord/student-resources/student-resources.component").then(
        (m) => m.StudentResourcesComponent,
      ),
  },
  {
    path: "completion",
    loadComponent: () =>
      import("./college-admin-dashbaord/completion/completion.component").then(
        (m) => m.CompletionComponent,
      ),
  },

  {
    path: "end-of-program",
    loadComponent: () =>
      import("./college-admin-dashbaord/end-of-program/end-of-program.component").then(
        (m) => m.EndOfProgramComponent,
      ),
  },
  {
    path: "application-report",
    loadComponent: () =>
      import("./admin-dashboard/reports/application-report/application-report.component").then(
        (m) => m.ApplicationReportComponent,
      ),
  },

  {
    path: "clearance/clearance-form",
    loadComponent: () =>
      import("./admin-dashboard/clearance/clearance-form/clearance-form.component").then(
            (m) => m.ClearanceFormComponent,
    ),
  },

  {
    path: "employment-status-report",
    loadComponent: () =>
      import("./admin-dashboard/reports/employment-status-report/employment-status-report.component").then(
        (m) => m.EmploymentStatusReportComponent,
      ),
  },
];
